<template>
  <CampoRelacionamentoCadastroRapido
    v-model="selecionado"
    :id="name"
    url="cfopscidades"
    cadastro-url="cadastro.CfopCidade"
    :item-text="formatCfopCidade"
    :label="label"
    @change="emit"
  />
</template>

<script>
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";

export default {
  name: "CampoCfopCidade",
  components: { CampoRelacionamentoCadastroRapido },

  props: {
    label: { type: String, default: "Cfop_cidade" },
    payload: { type: Object, required: false },
    name: { type: String, required: true },
  },

  data() {
    return {
      selecionado: {},
    };
  },

  mounted() {
    this.sincronizarPayload();
  },

  watch: {
    payload() {
      this.sincronizarPayload();
    },
  },

  methods: {
    emit() {
      this.$emit("return", this.selecionado);
    },

    sincronizarPayload() {
      if (this.payload) {
        this.selecionado = this.payload;
      }
    },

    formatCfopCidade(item) {
      if (!item) {
        return "";
      }

      const cidade = item.cidade || {};
      const estado = cidade.estado || {};
      const cfop = item.cfop || {};

      return [
        [cidade.nome, estado.sigla].filter(Boolean).join("/"),
        cfop.cfop,
        item.codigoTributacao,
      ]
        .filter(Boolean)
        .join(" - ");
    },
  },
};
</script>

<style></style>
